import { BuildBeneficiaries } from 'app/src/features/Shopping/shared/utils'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { Image } from 'app/src/shared/components'
import { euroFormatterIt, formatDateDDMMYYYY } from 'app/src/shared/helpers'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function MultiVoucherWidget(props: { orderListItem: shoppingApi.OrderListItem; parentOrder: shoppingApi.OrderDetails }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct' })

  const orderDetailVoucher = props.orderListItem?.purchaseDetails as shoppingApi.OrderDetailsPurchaseVoucher
  const amount = useMemo(() => {
    let importo = t('Common.freeAmount')

    if (props.orderListItem.priceDetails?.grossPrice && props.orderListItem.priceDetails.grossPrice > 0)
      importo = euroFormatterIt.format(props.orderListItem.priceDetails.grossPrice)
    return importo
  }, [t, props.orderListItem])

  const beneficiaries = useMemo(() => BuildBeneficiaries(props.parentOrder), [props.parentOrder])

  return (
    orderDetailVoucher && (
      <div className='printable card grid grid-cols-1 divide-x-0 divide-y-2 divide-dotted rounded-xl border border-solid border-[var(--primary-color)] bg-[var(--primary-color)] p-5 text-white lg:grid-cols-12 lg:divide-x-2 lg:divide-y-0'>
        <div className='min-w[300px] col-span-12 p-2 text-center lg:col-span-6 lg:pr-5 2xl:col-span-5'>
          <div className='mb-4' dangerouslySetInnerHTML={{ __html: t('Common.pwsLogo') }} />
          <>
            {orderDetailVoucher?.voucherImageUrl && (
              <div className='mx-auto mb-4 max-h-fit max-w-fit rounded-xl border bg-white p-[2px]'>
                <Image
                  pt={{ image: { className: 'max-w-[190px] max-h-[220px]' } }}
                  src={orderDetailVoucher?.voucherImageUrl}
                  alt='Immagine del codice del voucher'
                />
              </div>
            )}
            {orderDetailVoucher?.voucherCode && (
              <>
                <div
                  className='mb-1'
                  dangerouslySetInnerHTML={{
                    __html: t('MultiVoucher.voucherCodeDescription'),
                  }}
                />
                <div className='text-base font-bold'>
                  <span>{orderDetailVoucher.voucherCode}</span>
                </div>
              </>
            )}
          </>
        </div>
        <div className='lg:min-w[500px] col-span-12 mx-auto w-full p-2 lg:col-span-6 lg:pl-5 2xl:col-span-7'>
          <div className='mt-6 lg:mt-0'>{t('Voucher.orderIdLabel')}</div>
          <div className='mb-4 w-full break-words pt-2 font-bold uppercase lg:mb-0'>{props.orderListItem?.orderId ?? '-'}</div>
          <div className='mb-4 mt-2 hidden h-px w-full bg-white lg:block'></div>
          <div className='grid grid-cols-12'>
            <div className='col-span-12 mb-4 mt-2 lg:col-span-4 lg:my-0'>
              <div>{t('MultiVoucher.productDescription')}</div>
              <div className='pt-2 font-bold uppercase'>{props.orderListItem.productName}</div>
            </div>
            <div className='col-span-12 mt-2 lg:col-span-4 lg:col-start-7 lg:mt-0'>
              <div>{t('MultiVoucher.priceDescription')}</div>
              <div className='pt-2 font-bold uppercase'>{amount}</div>
            </div>
          </div>
          <div className='mt-4 grid grid-cols-12'>
            <div className='col-span-12 mb-4 mt-2 lg:col-span-4 lg:my-0'>
              <div>{t('MultiVoucher.buyerDescription')}</div>
              <div className='pt-2 font-bold uppercase'>{beneficiaries}</div>
            </div>
            <div className='col-span-12 mt-2 lg:col-span-4 lg:col-start-7 lg:mt-0'>
              <div>{t('MultiVoucher.buyDateDescription')}</div>
              <div className='pt-2 font-bold uppercase'>
                {orderDetailVoucher?.purchaseDate ? formatDateDDMMYYYY(new Date(orderDetailVoucher?.purchaseDate), true) : ''}
              </div>
            </div>
          </div>
          <div className='mt-4 grid grid-cols-12'>
            <div className='col-span-12 mt-2 lg:col-span-4 lg:mt-0'>
              <div>{t('MultiVoucher.expiringDateDescription')}</div>
              <div className='pt-2 font-bold uppercase'>
                {orderDetailVoucher?.expirationDate
                  ? formatDateDDMMYYYY(new Date(orderDetailVoucher?.expirationDate), true)
                  : t('MultiVoucher.noExpiringDateDescription')}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}
